import React,{useState,useEffect,useRef} from 'react';
import {Link} from 'react-router-dom';
import '../styles/HeaderFooter.css';

function RemoteHeader() {
  const [isNavOpen,setIsNavOpen]=useState(false);
  const [activeDropdown,setActiveDropdown]=useState(null);
  const navRef=useRef(null);

  useEffect(()=> {
    function handleClickOutside(event) {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setIsNavOpen(false);
        setActiveDropdown(null);
      }
    }
    document.addEventListener("mousedown",handleClickOutside);
    return ()=> document.removeEventListener("mousedown",handleClickOutside);
  },[]);

  const toggleDropdown=(name,e)=> {
    if (window.innerWidth < 992) {
      e.preventDefault();
      setActiveDropdown(activeDropdown===name ? null : name);
    }
  };

  return (
    <nav ref={navRef} className="navbar fixed-top navbar-expand-lg navbar-light">
      <div className="container">
        <Link className="navbar-brand d-flex align-items-center" to="/">
          <img src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1771019474594-Picture1.png" alt="Logo" />
          <div className="flex items-center">
            <div>
              <h1 className="text-xl font-bold text-gray-900 leading-tight">Quote Poster</h1>
              <p className="text-xs text-gray-500 font-medium">Transform quotes into art</p>
            </div>
          </div>
        </Link>
        <button className="navbar-toggler" type="button" onClick={()=> setIsNavOpen(!isNavOpen)} aria-expanded={isNavOpen} >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className={`collapse navbar-collapse justify-content-end ${isNavOpen ? 'show' : ''}`} id="navbarNav">
          <ul className="navbar-nav">
            {/* Home Link Added Here */}
            <li className="nav-item">
              <Link className="nav-link" to="/"> home </Link>
            </li>
            <li className={`nav-item dropdown ${activeDropdown==='about' ? 'show' : ''}`}>
              <a className="nav-link dropdown-toggle" href="#" onClick={(e)=> toggleDropdown('about',e)} onMouseEnter={()=> window.innerWidth >=992 && setActiveDropdown('about')} onMouseLeave={()=> window.innerWidth >=992 && setActiveDropdown(null)} > about us </a>
              <div className={`dropdown-menu dropdown-menu-right ${activeDropdown==='about' ? 'show' : ''}`} onMouseEnter={()=> window.innerWidth >=992 && setActiveDropdown('about')} onMouseLeave={()=> window.innerWidth >=992 && setActiveDropdown(null)} >
                <Link className="dropdown-item" to="/about-us"><i className="fas fa-user"></i> about us</Link>
                <Link className="dropdown-item" to="/contact-us"><i className="fas fa-envelope"></i> contact us</Link>
                <Link className="dropdown-item" to="/privacy-policy"><i className="fas fa-file-alt"></i> privacy policy</Link>
                <Link className="dropdown-item" to="/blog"><i className="fab fa-blogger"></i> blog</Link>
              </div>
            </li>
            <li className={`nav-item dropdown ${activeDropdown==='utility' ? 'show' : ''}`}>
              <a className="nav-link dropdown-toggle" href="#" onClick={(e)=> toggleDropdown('utility',e)} onMouseEnter={()=> window.innerWidth >=992 && setActiveDropdown('utility')} onMouseLeave={()=> window.innerWidth >=992 && setActiveDropdown(null)} > utility apps </a>
              <div className={`dropdown-menu dropdown-menu-right ${activeDropdown==='utility' ? 'show' : ''}`} onMouseEnter={()=> window.innerWidth >=992 && setActiveDropdown('utility')} onMouseLeave={()=> window.innerWidth >=992 && setActiveDropdown(null)} style={{maxHeight: '400px',overflowY: 'auto'}} >
                <a className="dropdown-item" href="https://lazypanda.app/short-url/" target="_blank"><i className="fas fa-link"></i> URL Short</a>
                <a className="dropdown-item" href="https://qrcode.now/" target="_blank"><i className="fas fa-qrcode"></i> Create QR Code</a>
                <a className="dropdown-item" href="https://todo.now" target="_blank"><i className="fas fa-list-ul"></i> ToDo List</a>
                <a className="dropdown-item" href="https://lazypanda.app/hex-to-rgb/" target="_blank"><i className="fas fa-paint-roller"></i> HEX to RGB</a>
                <a className="dropdown-item" href="https://lazypanda.app/color-shade-generator/" target="_blank"><i className="fas fa-swatchbook"></i> Color Shades</a>
                <a className="dropdown-item" href="https://lazypanda.app/gradient-generator/" target="_blank"><i className="fas fa-palette"></i> Gradient Generator</a>
                <a className="dropdown-item" href="https://lazypanda.app/currency-converter/" target="_blank"><i className="fas fa-coins"></i> Currency Converter</a>
                <a className="dropdown-item" href="https://lazypanda.app/password-generator/" target="_blank"><i className="fas fa-lock"></i> Password Gen</a>
                <a className="dropdown-item" href="https://lazypanda.app/password-tester/" target="_blank"><i className="fas fa-unlock"></i> Test Password</a>
                <a className="dropdown-item" href="https://lazypanda.app/word-counter-pro/" target="_blank"><i className="fas fa-calculator"></i> Word Counter</a>
                <a className="dropdown-item" href="https://lazypanda.app/text-generator/" target="_blank"><i className="fas fa-keyboard"></i> Text Generator</a>
                <a className="dropdown-item" href="https://lazypanda.app/pixel-to-centimeter/" target="_blank"><i className="fas fa-camera-rotate"></i> Pixel to Cms</a>
                <a className="dropdown-item" href="https://compiler.one" target="_blank"><i className="fas fa-code"></i> Online Compiler</a>
              </div>
            </li>
            <li className={`nav-item dropdown ${activeDropdown==='more' ? 'show' : ''}`}>
              <a className="nav-link dropdown-toggle" href="#" onClick={(e)=> toggleDropdown('more',e)} onMouseEnter={()=> window.innerWidth >=992 && setActiveDropdown('more')} onMouseLeave={()=> window.innerWidth >=992 && setActiveDropdown(null)} > more </a>
              <div className={`dropdown-menu dropdown-menu-right ${activeDropdown==='more' ? 'show' : ''}`} onMouseEnter={()=> window.innerWidth >=992 && setActiveDropdown('more')} onMouseLeave={()=> window.innerWidth >=992 && setActiveDropdown(null)} >
                <a className="dropdown-item" href="https://important.tips/" target="_blank"><i className="fas fa-bell"></i> Important.Tips</a>
                <a className="dropdown-item" href="https://codingdots.in/" target="_blank"><i className="fas fa-ellipsis-h"></i> CodingDots.in</a>
                <a className="dropdown-item" href="https://compiler.one/" target="_blank"><i className="fas fa-code"></i> Compiler.ONE</a>
                <a className="dropdown-item" href="https://patternprograms.dev/" target="_blank"><i className="fas fa-star"></i> Pattern Programs</a>
                <a className="dropdown-item" href="https://play.google.com/store/apps/dev?id=4684843660688611502" target="_blank"><i className="fas fa-mobile"></i> Android Apps</a>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
export default RemoteHeader;